module.exports = require('./helpers/bundle-url').getBundleURL('gR264') + "WorkfrontHero.7efae3c8.svg";